import { Outlet } from 'react-router-dom'
import { setAxiosSpaceContext } from '@/utils/axios.js'
import { useCurrentSpace } from '@/hooks/useCurrentSpace.jsx'

export default function SpaceGuard() {

    const { space } = useCurrentSpace()

    if (!space) {
        // User try to access non-existing account, meaning he doesn't have access to it
        console.log('No space?')
        return
    }

    setAxiosSpaceContext(space._id)

    return <Outlet />
}